import { html, nothing } from 'lit';
import { BoilerplateModal } from './boilerplate_modal';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { map } from 'lit/directives/map.js';

class ModalWishlistDeleteBoard extends BoilerplateModal {
  static get properties() {
    return {
      boards: { type: Array },
      loading_delete: { type: Boolean, state: true },
      loading_move: { type: Boolean, state: true },
      busy: { type: Boolean, state: true },
      moveBoard: { type: Object, state: true },
    };
  }

  constructor() {
    super();
    this.fromBottom = true;
    this.busy = false;
  }

  async handleChange() {
    const wishlist = await window.wishlist.retrieve();
    this.products = await window.wishlist.getProducts();
    this.boards = wishlist.boards;
    this.moveBoard = this.boards.find((board) => board.id === window.wishlist.BOARD_CONFIG.DEFAULT_BOARD_ID) || null;
  }

  handleSelectChange(e) {
    e.preventDefault();

    this.moveBoard = this.boards.find((board) => board.id === Number(e.target.value));
  }

  async connectedCallback() {
    super.connectedCallback();

    document.addEventListener('wishlist:initialise', this.handleChange.bind(this));

    document.addEventListener('wishlist:remove', this.handleChange.bind(this));

    document.addEventListener('wishlist:update', this.handleChange.bind(this));
  }

  async disconnectedCallback() {
    super.disconnectedCallback();

    document.removeEventListener('wishlist:initialise', this.handleChange.bind(this));

    document.removeEventListener('wishlist:remove', this.handleChange.bind(this));

    document.removeEventListener('wishlist:update', this.handleChange.bind(this));
  }

  async handleBoardDelete() {
    this.loading_delete = true;
    this.busy = true;
    try {
      await window.wishlist.deleteBoard(this.detail.id);
      this.toggleModal();
      window.dispatchEvent(
        new CustomEvent('analytics:gtag', {
          detail: {
            event: 'wishlist_board_delete',
            params: {
              board_name: this.detail.name,
              shopify_customer_id: window.theme?.customer?.id || null,
            },
          },
        })
      );
    } catch (error) {
      throw new Error('Error deleting board');
    } finally {
      this.loading_delete = false;
      this.busy = false;
    }
  }

  async handleBoardMove() {
    this.loading_move = true;
    this.busy = true;
    try {
      if (!this.detail?.items || this.detail.items.length === 0) {
        return;
      }

      const itemsToMove = this.detail.items.map((item) => {
        const { productId } = window.wishlist.parseWishlistId(item);
        return { productId };
      });

      await window.wishlist.moveProductToBoard(itemsToMove, this.detail.id, this.moveBoard.id);
      await window.wishlist.deleteBoard(this.detail.id);
      this.toggleModal();
    } catch (error) {
      throw new Error('Error moving products to default board');
    } finally {
      this.loading_move = false;
      this.busy = false;
    }
  }

  renderBody() {
    if (!this.detail) {
      return nothing;
    }

    return html`
      <div class="text_content">
        <p>${unsafeHTML(window.theme.strings.wishlist.delete_board_message)} <strong class="wishlist_delete_title">${this.detail.name}</strong></p>
      </div>
      <div class="form_same_line justify_center">
        <button type="button" class="btn btn-secondary w-full" @click=${this.toggleModal} ?disabled=${this.busy}>${unsafeHTML(window.theme.strings.wishlist.cancel)}</button>
        <button type="button" class="btn btn-primary w-full" @click=${this.handleBoardDelete} ?disabled=${this.loading_delete || this.busy}>
          ${this.loading_delete
        ? html`<bouncing-ellipsis></bouncing-ellipsis>`
        : html`${unsafeHTML(window.theme.strings.wishlist.delete)}`}
        </button>
      </div>
      ${this.detail.items?.length > 0 && this.moveBoard
        ? html`
        <select name="move_board_target" class="wishlist_move_select" @change=${this.handleSelectChange}>
          ${map(this.boards, (board) => board.id === this.detail?.id ? nothing : html`
          <option value=${board.id} ?selected=${board.id === this.moveBoard?.id}>${board.name}</option>
          `)}
        </select>

        <button type="button" class="btn btn-tertiary w-full wishlist_move_delete_btn" @click=${this.handleBoardMove} ?disabled=${this.loading || this.busy}>
            ${this.loading_move
            ? html`<bouncing-ellipsis></bouncing-ellipsis>`
            : html`${unsafeHTML(window.theme.strings.wishlist.delete_board_move)} <span class="move_link">${this.moveBoard.name}</span>`}
          </button>`
        : nothing}

    `;
  }
}

window.customElements.get('modal-wishlist-delete-board') || window.customElements.define('modal-wishlist-delete-board', ModalWishlistDeleteBoard);
